import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { billingApi } from '../../services/billingApi';

function formatDate(value) {
  if (!value) return '-';
  return new Date(value).toLocaleDateString();
}

export function RenewalBanner() {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const isClient = user?.role === 'USER' || user?.roles?.includes('user');

  useEffect(() => {
    if (!isClient) {
      setItems([]);
      return undefined;
    }
    let mounted = true;
    billingApi
      .renewalStatus()
      .then((data) => {
        if (mounted) setItems(Array.isArray(data) ? data.filter((item) => item.phase) : []);
      })
      .catch(() => {
        if (mounted) setItems([]);
      });
    return () => {
      mounted = false;
    };
  }, [isClient]);

  if (!items.length) return null;

  const item = items[0];
  return (
    <section className="mb-lg overflow-hidden rounded-2xl border border-primary/25 bg-gradient-to-r from-primary-container/20 via-surface to-secondary-container/25 p-md shadow-lg shadow-primary/10 animate-in fade-in slide-in-from-top-2 duration-500">
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-md">
        <div className="flex items-start gap-md">
          <div className="w-11 h-11 rounded-xl bg-primary text-on-primary flex items-center justify-center shadow-lg shadow-primary/20">
            <span className="material-symbols-outlined">bolt</span>
          </div>
          <div>
            <p className="font-label-caps text-label-caps uppercase text-primary">Renewal alert</p>
            <h3 className="text-title-sm font-title-sm text-on-surface">
              {item.service?.name || 'Assigned service'} is in {String(item.phase).replace('_', ' ')} status
            </h3>
            <p className="text-body-sm text-on-surface-variant mt-xs">
              Expires {formatDate(item.endDate)}. Grace ends {formatDate(item.graceEndsAt)}.
            </p>
          </div>
        </div>
        <div className="flex gap-sm">
          <Link to="/my-services" className="px-md py-sm rounded-lg bg-primary text-on-primary font-semibold hover:brightness-110 transition-all">
            Review service
          </Link>
          <Link to="/tickets/new" className="px-md py-sm rounded-lg border border-outline-variant text-on-surface font-semibold hover:bg-surface-container transition-all">
            Contact admin
          </Link>
        </div>
      </div>
    </section>
  );
}
